import posthog from 'posthog-js';
import { getEnvironment } from '../helpers';

function createExceptionFingerprint(type: string, message: string): string {
  return `${type}:${message}`;
}

export function logEvent(eventName: string, properties?: Record<string, unknown>) {
  posthog?.capture(eventName, properties);
}

export function logException(error: Partial<Error> | string, properties?: Record<string, unknown>) {
  let errorToCapture: Error;

  if (typeof error === 'string') {
    errorToCapture = new Error(error);
  } else if (error instanceof Error) {
    errorToCapture = error;
  } else {
    const message = error?.message || 'Unknown error';

    errorToCapture = new Error(message);
    errorToCapture.name = error?.name || 'Error';
    errorToCapture.stack = error?.stack || errorToCapture.stack;
  }

  const fingerprint = createExceptionFingerprint(errorToCapture.name, errorToCapture.message);

  posthog?.captureException(errorToCapture, {
    ...properties,
    $current_url: window.location.href,
    $exception_fingerprint: fingerprint,
    $exception_level: 'error',
    $environment: getEnvironment(window.location.host),
  });
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!userId) return;

  posthog?.identify(userId, properties);
}
